import React, { useState, useEffect } from 'react';
import '../../css/onboardingFirstSteps.css';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import { useMobileMediaQuery, useTabletMediaQuery, useUltraMobileMediaQuery } from '../../utils';
import CustomButton from '../../components/CustomButton';
import GifAnim from '../../components/GifAnim';
import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";
import { useSelector } from 'react-redux';
import { GTM } from '../../components/GTM/GTM';

function OnboardingStepOne({ onNext, onSkip, mainImgSvg }) {

    const [isLoading, setIsLoading] = useState(true);
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const isUltraMobile = useUltraMobileMediaQuery();
    const isClientId = useSelector((state) => state.onboardingUserData.isClientId);

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, [isLoading]);

    useEffect(() => {
        const delay = setTimeout(() => {
            setIsLoading(false);
        }, 2000);

        return () => clearTimeout(delay);
    }, []);



    return (
        <>
            <GTM />
            <Header />
            {!isTablet &&
                <>
                    <div className='mainBgViewContainerStepsStackMobileTablet'></div>
                </>
            }
            {(isLoading && isClientId === '') ?
                <GifAnim />
                :
                <div className={isTablet ? 'mainViewContainerStepsStack' : (isMobile ? 'mainViewContainerStepsStackTablet' : 'mainViewContainerStepsStackMobile')}>
                    {!isTablet &&
                        <>
                            <div className={isMobile ? 'mainImgViewStepsStackTablet' : 'mainImgViewStepsStackMobile'}>
                                <img src={mainImgSvg} alt="imagem" className={isMobile ? "mainImgStepsStackTablet" : (isUltraMobile ? "mainImgStepsStackPreMobile" : "mainImgStepsStackMobile")} />
                            </div>
                        </>
                    }
                    <div className={isTablet ? 'firstTxtViewContainerStepsStack' : (isMobile ? 'firstTxtViewContainerStepsStackTablet' : 'firstTxtViewContainerStepsStackMobile')}>
                        {isTablet ?
                            <div className='firstTitleViewStepsStack'>
                                <span className='textTitlePart1StepsStack'>Damos-lhe as boas-vindas à sua </span>
                                <span className='textTitlePart2StepsStack'>Carteira Virtual.</span>
                            </div>
                            :
                            <div className='firstTitleViewStepsStack'>
                                {isMobile ?
                                    <div className='textTitlePart1StepsStackTablet'>Damos-lhe as boas-vindas à sua Carteira Virtual.</div>
                                    :
                                    <div className='textTitlePart1StepsStackMobile'>
                                        <span className='textTitlePart1StepsStackMobile'>Damos-lhe as boas-vindas </span>
                                        <span className='textTitlePart1StepsStackMobile'>à sua </span>
                                        <span className='textTitlePart2StepsStackMobile'>Carteira Virtual.</span>
                                    </div>
                                }
                            </div>
                        }
                        <div className={isTablet ? 'secondTitleViewStepsStack' : (isMobile ? 'secondTitleViewStepsStackTablet' : 'secondTitleViewStepsStackMobile')}>Disponível para todos, com ou sem seguro Médis.</div>
                        {isTablet ?
                            <>
                                <div className='secondSmallTitleViewStepsStack'>Sempre que fizer compras na nossa rede de parceiros, recebe de</div>
                                <div className='secondSmallTitleViewStepsStack'>volta uma percentagem do valor em saldo da Carteira Virtual.</div>
                            </>
                            :
                            <div className='firstTitleViewStepsStack'>
                                {isMobile ?
                                    <div className='secondSmallTitleViewStepsStackTablet'>Sempre que fizer compras na nossa rede de parceiros, recebe de volta uma percentagem do valor em saldo da Carteira Virtual.</div>
                                    :
                                    <>
                                        <div className='secondSmallTitleViewStepsStackMobile'>Sempre que fizer compras na nossa rede de parceiros, recebe de volta uma percentagem do valor em saldo da Carteira Virtual.</div>
                                    </>
                                }
                            </div>
                        }
                        <div className={isTablet ? 'btnsViewStepsStack' : (isMobile ? 'btnsViewStepsStackTablet' : 'btnsViewStepsStackMobile')}>
                            <div className={isTablet ? 'divBtnSaltarStepsStack' : (isMobile ? 'divBtnSaltarStepsStackTablet' : 'divBtnSaltarStepsStackMobile')}>
                                <CustomButton
                                    text={'Saltar'}
                                    textColor={'#00214D'}
                                    onPress={() => onSkip()}
                                    hasSubLine
                                    hasSubLineSmall
                                    hasSubLineSmallColor={'#00214D'}
                                    fontSize={'14px'}
                                />
                            </div>
                            <div className={isTablet ? 'divBtnNextStepsStack' : (isMobile ? 'divBtnSaltarStepsStackTablet' : 'divBtnNextStepsStackMobile')}>
                                <CustomButton
                                    text={'Próximo'}
                                    textColor={'#00214D'}
                                    onPress={() => onNext()}
                                    color={isTablet ? '#fff' : (isMobile ? '#fff' : '#fff')}
                                    hasArrow
                                    iconColor={'#00214D'}
                                    hasShadowWithe
                                />
                            </div>
                        </div>
                        {
                            isTablet ? null : (isMobile ? (
                                <>
                                    <div className='cirlceSelectedViewStepsStackMobile'>
                                        <div className='cirlceSelectedStepsStackMobile'>
                                            <div className='circleMainvViewStepsStack'>
                                                <button className='iconArrowLeftViewStepsStack' disabled>
                                                    <FaArrowLeftLong className='iconArrowStepsStack' />
                                                </button>
                                                <div className='circleContainerStepsStack'>
                                                    <div className='circleSelectedViewStepsStack' />
                                                </div>
                                                <div className='circleContainerStepsStack'>
                                                    <div className='circleViewStepsStack' />
                                                </div>
                                                <div className='circleContainerStepsStack'>
                                                    <div className='circleViewStepsStack' />
                                                </div>
                                                <div className='circleContainerStepsStack'>
                                                    <div className='circleViewStepsStack' />
                                                </div>
                                                <button className='iconArrowRightViewStepsStack' onClick={() => onNext()}>
                                                    <FaArrowRightLong className='iconArrowStepsStack' />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) :
                                <>
                                    <div className='cirlceSelectedViewStepsStackMobile'>
                                        <div className='cirlceSelectedStepsStackMobile'>
                                            <div className='circleMainvViewStepsStack'>
                                                <button className='iconArrowLeftViewStepsStack' disabled>
                                                    <FaArrowLeftLong className='iconArrowStepsStack' />
                                                </button>
                                                <div className='circleContainerStepsStack'>
                                                    <div className='circleSelectedViewStepsStack' />
                                                </div>
                                                <div className='circleContainerStepsStack'>
                                                    <div className='circleViewStepsStack' />
                                                </div>
                                                <div className='circleContainerStepsStack'>
                                                    <div className='circleViewStepsStack' />
                                                </div>
                                                <div className='circleContainerStepsStack'>
                                                    <div className='circleViewStepsStack' />
                                                </div>
                                                <button className='iconArrowRightViewStepsStack' onClick={() => onNext()}>
                                                    <FaArrowRightLong className='iconArrowStepsStack' />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )
                        }
                    </div>
                    {isTablet &&
                        <>
                            <div className='subFirstImgViewContainerStepsStack'>
                                <div className='firstImgViewContainerStepsStack'>
                                    <div className='mainImgViewStepsStack'>
                                        <img src={mainImgSvg} alt="imagem" className="mainImgStepsStack" />
                                    </div>
                                    <div className='cirlceSelectedStepsStack'>
                                        <div className='circleMainvViewStepsStack'>
                                            <button className='iconArrowLeftViewStepsStack' disabled>
                                                <FaArrowLeftLong className='iconArrowStepsStack' />
                                            </button>
                                            <div className='circleContainerStepsStack'>
                                                <div className='circleSelectedViewStepsStack' />
                                            </div>
                                            <div className='circleContainerStepsStack'>
                                                <div className='circleViewStepsStack' />
                                            </div>
                                            <div className='circleContainerStepsStack'>
                                                <div className='circleViewStepsStack' />
                                            </div>
                                            <div className='circleContainerStepsStack'>
                                                <div className='circleViewStepsStack' />
                                            </div>
                                            <button className='iconArrowRightViewStepsStack' onClick={() => onNext()}>
                                                <FaArrowRightLong className='iconArrowStepsStack' />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>
            }
            <Footer />
        </>
    )
}

export default OnboardingStepOne;